import React, { useState, useEffect } from 'react';
import { Button, Form, Row, Col, Card } from 'antd';
import { InputCheckbox, SelectField, DateField } from 'Atoms/FormElement';
import { useForm } from 'react-hook-form';
import dayjs from 'dayjs';
import DateRangeDropdown from 'Modules/Application/components/DateRangeDropdown';
import { useTranslate } from 'Translate';

export default (props) => {
  const {checkedCount, setCheckedCount, setIsExport} = props
  const { control, handleSubmit, setValue, getValues } = useForm();
  const i18n = useTranslate();
  const { t } = i18n;

  useEffect(() => {
    if (props) {
      if (!getValues().start_date) {
        setValue('start_date', dayjs());
        setValue('dateRange', { label: t("General.today"), value: 'today' });
      }
      if (!getValues().end_date) {
        setValue('end_date', dayjs());
      }
    }
  }, [props])

  // const onSubmit = (val) => {
  //   val["checkedCount"] = checkedCount;
  //   props.onSearch(val)
  // }

  const clearProps = () => {
    setValue("outlets", "");
    setValue("statistics", "");
    setValue("tender", "");
    setValue("discount", "");
    setValue("tax", "");
    setValue("order_type", "");
    setValue("cash_management", "");
    setValue("session", "");
    setValue("voided_sales", "");
    setValue("category", "");
    setValue("category_2", "");
    setValue("category_3", "");
    setValue("brand", "");
    setValue("brand_group", "");
    setValue("season", "");
    setValue("class", "");
    setValue("department", "");
    setValue("sales_category", "");
    setValue("sales_brand", "");
    setValue("sales_class", "");
    setCheckedCount(0);
    props.onSearch({});
  }

  return (
    <Form onFinish={handleSubmit(props.onSubmit)} layout="inline" className='w-100' id={'daily-summary-filter'}>
      <Row className='w-100' gutter={[10, 10]}>
        <Col flex="auto">
          <SelectField
            fieldname='outlets'
            label=''
            class='m-0 w-100 default-select'
            initValue={''}
            control={control}
            iProps={{ placeholder: t("General.outlet"), isMulti: true }}
            selectOption={props.field1}
          />
        </Col>
        <Col flex="auto">
          <SelectField
            fieldname='non_sales'
            label=''
            class='mb-0 w-100 default-select'
            initValue={{ label: "Non Sales: All", value: "all" }}
            control={control}
            selectOption={[{
              label: "Non Sales: All",
              value: "all"
            }, {
              label: "Non Sales: No",
              value: "no"
            }, {
              label: "Non Sales: Yes",
              value: "yes"
            }]}
            iProps={{ placeholder: 'Is Non Sales' }}
          />
        </Col>
        <DateRangeDropdown control={control} onSetValue={setValue} placeholderValue={t("Inventory.business_date")} isRequired={false} />
      </Row>
      <Row className='w-100 mt-1' gutter={[10, 10]}>
        <Card bordered={false} className='w-100 shadow-card'>
          <Row gutter={[10, 10]}>
            {/* those with d-none = temporary hide */}
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`statistics`}
                label={t("SalesReporting.statistics")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
                onChange={(e) => {
                  let temp = checkedCount;
                  if(e) {
                    temp += 5
                  }else{
                    temp -= 5
                  }
                  setCheckedCount(temp);
                }}
              />
            </Col>
            <Col span={12}>
              <InputCheckbox
                fieldname={`tender`}
                label={t("SalesReporting.tender")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
                onChange={(e) => {
                  let temp = checkedCount;
                  if (e) {
                    temp += 7
                  } else {
                    temp -= 7
                  }
                  setCheckedCount(temp);
                }}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`discount`}
                label={t("Delete.discount")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`tax`}
                label={t("General.tax")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
                onChange={(e) => {
                  let temp = checkedCount;
                  if (e) {
                    temp += 1
                  } else {
                    temp -= 1
                  }
                  setCheckedCount(temp);
                }}
              />
            </Col>
            <Col span={12}>
              <InputCheckbox
                fieldname={`order_type`}
                label={t("SalesReporting.order_type")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
                onChange={(e) => {
                  let temp = checkedCount;
                  if (e) {
                    temp += 9
                  } else {
                    temp -= 9
                  }
                  setCheckedCount(temp);
                }}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`cash_management`}
                label={t("SalesReporting.cash_mgmt")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`session`}
                label={t("SalesReporting.session")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`voided_sales`}
                label={t("SalesReporting.voided_sales")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
                onChange={(e) => {
                  let temp = checkedCount;
                  if (e) {
                    temp += 2
                  } else {
                    temp -= 2
                  }
                  setCheckedCount(temp);
                }}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`category`}
                label={t("Delete.category")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
                onChange={(e) => {
                  let temp = checkedCount;
                  if (e) {
                    temp += 42
                  } else {
                    temp -= 42
                  }
                  setCheckedCount(temp);
                }}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`category_2`}
                label={t("SalesReporting.category_2")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`category_3`}
                label={t("SalesReporting.category_3")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`brand`}
                label={t("SalesReporting.brand")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`brand_group`}
                label={t("SalesReporting.brand_group")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`season`}
                label={t("SalesReporting.season")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`class`}
                label={t("SalesReporting.class")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`department`}
                label={t("SalesReporting.department")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
                onChange={(e) => {
                  let temp = checkedCount;
                  if (e) {
                    temp += 6
                  } else {
                    temp -= 6
                  }
                  setCheckedCount(temp);
                }}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`sales_category`}
                label={t("SalesReporting.sales_category")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`sales_brand`}
                label={t("SalesReporting.sales_brand")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
            <Col span={4} className='d-none'>
              <InputCheckbox
                fieldname={`sales_class`}
                label={t("SalesReporting.sales_class")}
                class="mb-0 wauto"
                control={control}
                initValue={false}
              />
            </Col>
          </Row>
        </Card>
      </Row>
      <Row className='w-100 mt-1' gutter={[10, 10]} justify={'end'}>
        <Col flex="70px">
          <Button className='w-100' danger size='large' type='primary' htmlType='button' onClick={() => clearProps()}>{t("General.clear")}</Button>
        </Col>
        <Col flex="70px">
          <Button className='w-100' size='large' type='primary' htmlType='submit' onClick={() => setIsExport(false)}>{t("General.search")}</Button>
        </Col>
      </Row>
    </Form>
  )
}